import {OperableTarget} from './OperableTarget';
import {OperableAccount} from './OperableTarget/OperableAccount';
import {OperationModel} from './OperationModel';

type OperationSubtype = 'buy' | 'sell' | 'send' | 'receive';

export type OperationAlias = OperationSubtype | OperationModel.Type;

export namespace OperationAlias {
    export const toHumanLabel = (name: OperationAlias): string => {
        switch (name) {
            case 'buy':
                return 'Buy';
            case 'sell':
                return 'Sell';
            case 'send':
                return 'Send';
            case 'receive':
                return 'Receive';
            case 'topup':
                return 'Top up';
            case 'withdraw':
                return 'Withdraw';
            case 'exchange':
                return 'Exchange';
        }
    };

    export const from = (operation: OperationModel.Identity): OperationAlias => {
        const alias = aliasTable[operation.type]?.[operation.account.type]?.[operation.target.type];
        const type = operation.type as OperationAlias;
        return alias ?? type;
    };

    const aliasTable: DeepPartial<
        Record<OperationModel.Type, Record<OperableAccount.Type, Record<OperableTarget.Type, OperationAlias>>>
    > = {
        exchange: {
            fiat: {crypto: 'buy', stablecoin: 'buy'},
            crypto: {fiat: 'sell'},
            stablecoin: {fiat: 'sell'},
        },
        withdraw: {
            crypto: {wallet: 'send'},
            stablecoin: {wallet: 'send'},
        },
        topup: {
            crypto: {wallet: 'receive'},
            stablecoin: {wallet: 'receive'},
        },
    };
}

type DeepPartial<T> = T extends object
    ? {
          [P in keyof T]?: DeepPartial<T[P]>;
      }
    : T;
